
    const data = {"name":"src/core/icons/window-minimize","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M20 14H4v-4h16\"/>","originalColors":[],"stopColors":[]}}

            export default data
            